import { useState } from "react";
import { AcademicCapIcon, EyeIcon, FlagIcon, PencilSquareIcon, UserGroupIcon } from "@heroicons/react/24/outline";
import { Button, Tag } from "../ui";
import SetupDialog from "../calls/SetupDialog";
import { callPhaseOf, useAbroadCall } from "./model";
import CallPreview from "./CallPreview";
import CommitteeTab from "./CommitteeTab";
import DetailsTab from "./DetailsTab";
import ProgrammesTab from "./ProgrammesTab";
import StatusTab from "./StatusTab";

const TABS = [
  { value: "details", label: "Details", icon: <PencilSquareIcon className="h-4 w-4" /> },
  { value: "programmes", label: "Programmes", icon: <AcademicCapIcon className="h-4 w-4" /> },
  { value: "committee", label: "Committee", icon: <UserGroupIcon className="h-4 w-4" /> },
  { value: "status", label: "Status", icon: <FlagIcon className="h-4 w-4" /> },
];

const PANELS = { details: DetailsTab, programmes: ProgrammesTab, committee: CommitteeTab, status: StatusTab };

// A loan call's whole set-up in one dialog; the DG and the Minister see it read-only. A draft has a full preview.
export default function CallSetupDialog({ callId, onClose }) {
  const { data: call, isPending, isError, refetch } = useAbroadCall(callId);
  const phase = call && callPhaseOf(call);
  const [previewing, setPreviewing] = useState(false);

  return (
    <SetupDialog
      open={Boolean(callId)}
      onClose={onClose}
      title={call?.name}
      tag={phase && <Tag color={phase.color}>{phase.label}</Tag>}
      tabs={TABS}
      panels={PANELS}
      panelProps={{ call }}
      isPending={isPending}
      isError={isError}
      onRefresh={refetch}
      readOnlyNote="Read-only: only the HEC Admin changes loan calls."
      actions={
        call?.state === "DRAFT" && (
          <>
            <Button variant="outline" icon={<EyeIcon className="h-4 w-4" />} onClick={() => setPreviewing(true)}>
              Preview
            </Button>
            {previewing && <CallPreview call={call} onClose={() => setPreviewing(false)} />}
          </>
        )
      }
    />
  );
}
